"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var TextArea_1 = __importDefault(require("../../../../common/TextInput/TextArea"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var CategorySelector_1 = __importDefault(require("../../Knowledge/Selectors/CategorySelector"));
var DataType_1 = __importDefault(require("../../Knowledge/Selectors/DataType"));
var SortingSelector_1 = __importDefault(require("../../Knowledge/Selectors/SortingSelector"));
var validateForm_1 = require("../Validate/validateForm");
var MonitoringQuesAnswer_1 = __importDefault(require("./MonitoringQuesAnswer"));
var ImagePicker_1 = __importDefault(require("../../../../common/ImagePicker/ImagePicker"));
var MonitoringQuestionSelector_1 = __importDefault(require("../../Knowledge/Selectors/MonitoringQuestionSelector"));
var MonitoringTable_1 = __importDefault(require("./MonitoringTable"));
var client_1 = require("@apollo/client");
var Queries_1 = require("../Graphql/Queries");
var Mutation_1 = require("../Graphql/Mutation");
var common_1 = require("../../../../common");
var MonitoringQuestion = function (props) {
    var _a, _b, _c;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _d = (0, react_1.useState)(null), error = _d[0], setError = _d[1];
    var _e = (0, react_i18next_1.useTranslation)(), t = _e.t, i18n = _e.i18n;
    var getCurrentLang = i18n.language;
    var arr = props.language;
    var audioRef = (0, react_1.createRef)();
    var _f = (0, react_1.useState)({
        id: null,
        name: JSON.stringify(props.language),
        category: null,
        data_type: null,
        sorting_order: null,
        organization_id: organization.id,
        answer: [],
        audio: arr,
        dependency: null,
    }), formData = _f[0], setFormData = _f[1];
    var _g = (0, react_1.useState)({ audio: null }), audioFile = _g[0], setAudioFile = _g[1];
    var _h = (0, react_1.useState)(false), showAnnswer = _h[0], setShowAnswer = _h[1];
    var _j = (0, react_1.useState)({
        loading: false,
        error: null,
        success: null,
    }), status = _j[0], setStatus = _j[1];
    console.log({ status: status });
    var resetDocumentRef = function () {
        audioRef.current.value = null;
    };
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
    }, []);
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
        setAudioFile({ audio: null });
    }, [getCurrentLang]);
    (0, react_1.useEffect)(function () {
        if (props.saveClickStatus) {
            props.updateSaveClickStatus();
            saveMonitor();
        }
    }, [props.saveClickStatus]);
    var saveMonitor = function () {
        var res = (0, validateForm_1.ValidateMonitorForm)(formData, getCurrentLang);
        if (res.status === "error") {
            setError(res);
        }
        else {
            window.scrollTo(0, 0);
            props.saveMonitorData(formData);
        }
    };
    var callQuesWithAnswer = (0, client_1.useLazyQuery)(Queries_1.GET_MONITORING_QUESTION_WITH_ANSWER, {
        fetchPolicy: "network-only",
        variables: {
            organization_id: organization.id,
            published: true,
        },
    })[0], _k = (0, client_1.useMutation)(Mutation_1.UPSERT_MONITORING_QUESTION_ANSWER, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), callUpsertMonitor = _k[0], upsertMonitorResponse = _k[1];
    var onHandleChange = function (value, name, type) {
        setError(null);
        if (type === "json") {
            try {
                var dataObj_1 = JSON.parse(formData[name] || "{}");
                dataObj_1[getCurrentLang] = value;
                setFormData(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[name] = JSON.stringify(dataObj_1), _a)));
                });
            }
            catch (e) {
                console.error("Error parsing JSON:", e);
            }
        }
        else if (type === "obj") {
            var audio_file_1 = value.audio_file;
            if (audio_file_1) {
                setAudioFile({
                    audio: audio_file_1.name,
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["audio"] = __assign(__assign({}, prevState["audio"]), (_b = {}, _b[getCurrentLang] = audio_file_1, _b)), _a)));
                });
            }
        }
        else {
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    var onEditQuestion = function (item) {
        var formatted_data_type = {
            id: item === null || item === void 0 ? void 0 : item.data_type.id,
            value: item === null || item === void 0 ? void 0 : item.data_type.id,
            name: item === null || item === void 0 ? void 0 : item.data_type.name,
        };
        var output = (item === null || item === void 0 ? void 0 : item.monitoring_anwers.map(function (answer) { return ({
            id: answer.id,
            name: answer.name,
            sorting_order: answer.sorting_order,
        }); })) || [];
        setShowAnswer(formatted_data_type &&
            ((formatted_data_type === null || formatted_data_type === void 0 ? void 0 : formatted_data_type.name) === "Text" ||
                (formatted_data_type === null || formatted_data_type === void 0 ? void 0 : formatted_data_type.name) === Number)
            ? false
            : true);
        setFormData({
            id: item.id,
            name: item.name,
            category: item.monitoring_category_id,
            data_type: formatted_data_type.id,
            answer: output,
            sorting_order: item.order_by,
            dependency: item.dependent_id,
            organization_id: organization.id,
            audio: props.language,
            published: true,
        });
    };
    var onQuestiondelete = function (formData) {
        window.scroll(0, 0);
        setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        var variables = {
            id: formData.id,
            name: formData.name,
            monitoring_category_id: formData.monitoring_category_id,
            organization_id: formData.organization_id,
            order_by: formData.order_by,
            data_type_id: formData.data_type_id,
            answer: (formData.monitoring_anwers.length > 0 &&
                formData.monitoring_anwers.map(function (ans) { return ({
                    id: ans.id || null,
                    name: ans.answer || ans.name,
                    sorting: ans.sorting || null,
                    published: true,
                }); })) ||
                [],
            published: false,
            audio: formData.audio || null,
            dependent_id: formData.dependent_id,
        };
        callUpsertMonitor({ variables: { input: [variables] } })
            .then(function (res) {
            callQuesWithAnswer();
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: res.data.upsertMonitoringQuestionAnswer, loading: false })); });
        })
            .catch(function (e) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
            return e;
        });
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        (upsertMonitorResponse === null || upsertMonitorResponse === void 0 ? void 0 : upsertMonitorResponse.loading) && react_1.default.createElement(common_1.Spinner, null),
        react_1.default.createElement("div", { className: "form-container" },
            react_1.default.createElement(CategorySelector_1.default, { error: error && error.field === "category" && error.message, label: t("category"), list: ((_a = props.categoryList) === null || _a === void 0 ? void 0 : _a.data)
                    ? (_b = props.categoryList) === null || _b === void 0 ? void 0 : _b.data.getMonitoringCategory
                    : [], updateCategory: function (val) { return onHandleChange(val, "category", ""); }, value: formData.category }),
            react_1.default.createElement(TextArea_1.default, { error: error && error.field === "name" && error.message, label: t("name"), onChange: function (e) { return onHandleChange(e.target.value, "name", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(formData.name, getCurrentLang.toLowerCase(), t) }),
            react_1.default.createElement(SortingSelector_1.default, { value: formData.sorting_order, list: props.sortingList, onChange: function (e) {
                    return onHandleChange(e.sorting_id, "sorting_order", "");
                } }),
            react_1.default.createElement(DataType_1.default, { label: t("data_type"), value: formData.data_type, onChange: function (val) {
                    onHandleChange(val, "data_type", "");
                    // setShowAnswer(
                    //   val?.label === "Text" || val?.label === Number ? false : true,
                    // );
                    setShowAnswer(JSON.parse(val === null || val === void 0 ? void 0 : val.name)["en"].toLowerCase() === "text" ||
                        JSON.parse(val === null || val === void 0 ? void 0 : val.name)["en"].toLowerCase() === "number"
                        ? false
                        : true);
                } }),
            showAnnswer && (react_1.default.createElement(MonitoringQuesAnswer_1.default, { languages: props.language || {}, editableAnswers: formData.answer, error: error, handleMultipleAnswer: function (e) {
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a["answer"] = e, _a)));
                    });
                } })),
            react_1.default.createElement(ImagePicker_1.default, { fileName: audioFile, id: "audio", imagechange: function (audio_file) {
                    var file = { audio_file: audio_file };
                    onHandleChange(file, "audio", "obj");
                }, imgref: audioRef, label: t("audio_question"), mediatype: "audio" }),
            react_1.default.createElement(MonitoringQuestionSelector_1.default, { label: t("dependency"), value: formData.dependency, onChange: function (val) { return onHandleChange(val, "dependency", ""); } })),
        react_1.default.createElement(MonitoringTable_1.default, { getQuesAns: (_c = props.sortingList) !== null && _c !== void 0 ? _c : [], hasHierarchy: false, onQuestionedit: function (item) { return onEditQuestion(item); }, onQuestiondelete: function (item) { return onQuestiondelete(item); } })));
};
exports.default = MonitoringQuestion;
